<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
    background-color:#FFFFFF;
    .banner
        height:422px;
        background-color:#FCFCFC;
        padding:34px 15%;
        display:flex;
        .banner-list
            width:970px;
            height:354px;
            margin-right:18px;
            .banners
                height:354px;
                width:970px;
                .banner-img
                    cursor:pointer;
                    width:970px;
                    height:354px;
        .consult
            width:332px;
            height:354px;
            background-color:#FFFFFF;
            border-radius:5px;
            border:1px solid #F7F7F7;
            position: relative;
            .c-top
                display:flex;
                align-items:center;
                margin-bottom:5px;
                padding:10px 20px;
                .t-left
                    width:4px;
                    height:19px;
                    background-color:#2751CB;
                    border-radius:2px;
                .t-title
                    margin-left:10px;
                    color:#071336;
                    font-size:22px;
                    font-weight:500;
            .c-mian
                margin-left:15px;
                padding:10px 20px;
                .c-title
                    height:17px;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(7,19,54,1);
                    line-height:17px;
                .c-list
                    margin-top:24px;
                    display:flex;
                    .c-time
                        width:50px;
                        height:20px;
                        font-size:12px;
                        font-weight:400;
                        color:rgba(7,19,54,0.4);
                        line-height:20px;
                        margin-right:15px;
                    .c-desc
                        width:197px;
                        height:40px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(7,19,54,1);
                        line-height:20px;
            .c-btn
                position: absolute;
                bottom:0;
                width:332px;
                height:62px;
                background-color:#2751CB;
                display:flex;
                justify-content:center;
                align-items:center;
                cursor:pointer;
                .btn-img
                    width:28px;
                    height:30px;
                    margin-right:10px;
                .btn-name
                    height:27px;
                    font-size:21px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:26px;
    .c-banner
        padding:34px 15%;
        .c-banner-img
            width:1319px;
            height:155px;
</style>
<style lang="stylus">
.banners
    .el-carousel__container
        height:354px;
        position:static !important;
</style>
<template>
  <div class="main">
    <div class="banner noSelect">
        <div class="banner-list">
            <el-carousel trigger="click" class="banners">
              <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                <img :src="item.image" class="banner-img" @click.stop="bannerTo(item.url)">
              </el-carousel-item>
            </el-carousel>
        </div>
        <div class="consult">
            <div class="c-top">
                <div class="t-left"></div>
                <div class="t-title">企业法律咨询</div>
            </div>
            <div class="c-mian">
                <div class="c-title">律师实时在线，人机协作，一对一服务</div>
                <div style="height:192px;overflow:hidden;" @mouseenter="closeAnimation()" @mouseleave="autoPlay()">
                    <div :style="{top, transition}" style="position:relative;transition: top .5s;height:192px;">
                        <div v-for="(item,index) in consultList" :key="index" class="c-list">
                            <div class="c-time">{{item.time | timeconvert}}</div>
                            <!-- <div class="c-desc">{{item.desc}}</div> -->
                            <div class="c-desc" v-if="item.lawyer_name == ''">{{filterName(item.user_name,item.phone)}}  发起了咨询！</div>
                            <!-- item.user_name| filtername -->
                            <div class="c-desc" v-else><span>{{filterName(item.user_name,item.phone)}}</span>获得了  <span style="cursor:pointer;" @click.stop="$router.push({name: 'personalCenter', params: {id: item.lawyer_id}})">{{item.lawyer_name}}律师 </span> 的咨询解答</div>
                        </div>
                        <div v-for="(item,index) in consultList" :key="'b'+index" class="c-list">
                            <div class="c-time">{{item.time | timeconvert}}</div>
                            <div class="c-desc" v-if="item.lawyer_name == ''">{{filterName(item.user_name,item.phone)}}  发起了咨询！</div>
                            <div class="c-desc" v-else><span>{{filterName(item.user_name,item.phone)}}</span>获得了  <span style="cursor:pointer;" @click.stop="$router.push({name: 'personalCenter', params: {id: item.lawyer_id}})">{{item.lawyer_name}}律师 </span> 的咨询解答</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-btn" @click="gotoHonsenChat">
                <img src="/static/img/consult-w.png" class="btn-img">
                <div class="btn-name">立即咨询</div>
            </div>
        </div>
    </div>
    
    <!-- 商事律师 -->
    <LawyerList></LawyerList>

    <!-- 企业法务通 -->
    <Course></Course>
    <!-- 企业法务通banner -->
    <div class="c-banner">
        <img src="/static/img/course_banner.png" class="c-banner-img">
    </div>

    <!-- 商事法律事件专栏 -->
    <CommercialLaw></CommercialLaw>
  </div>
</template>

<script>
import LawyerList from "@/components/common/lawyerList";
import Course from "@/components/common/course";
import CommercialLaw from "@/components/common/commercialLaw";
import moment from 'moment';

export default {
  name: 'home',
  data () {
    return {
        bannerLists:[
          {image:'/static/img/banner1.png'}
        ],
        bannerList:[],
        consultList:[],
        activeIndex: 0,
        animation: null,
        timeStep: 2000
      }
    },
    components: {LawyerList,Course,CommercialLaw},
    computed: {
        top () {
            return - this.activeIndex * 64 + 'px'
        },
        transition() {
            return this.activeIndex === 0 ? 'none' : 'top 0.5s';
        },
        loginStatus() {
          return this.$store.state.loginStatus;
        },
        // 是否为弘商管家
        honsenOffice() {
          if (this.loginStatus && this.$store.state.mineInfo.honsen_office_clerk.length) {
            if (this.$store.state.mineInfo.honsen_office_clerk[0] === 1) {
              return true
            } else {
              return false
            }

          } else {
            return false
          }
        },
    },
    mounted() {
        moment.locale('zh-cn');
        this.getBanner();
        this.autoPlay();
        this.getConsultList();
    },
    methods:{
        //获取banner图
        getBanner(){
            let url = 'wxm/banner';
            let param = {
                device:1  //1是pc，2是小程序
            };
            this.$http.get(url,{params:param}).then(res =>{
                if(res.data.data.length){
                    this.bannerList = res.data.data;
                }else{
                    this.bannerList = this.bannerLists;
                }
            })
        },
        //banner跳转
        bannerTo(url){
            //跳转咨询为consult，咨询需要登录，且有三端。
            if(url == 'consult'){
                this.gotoHonsenChat();
            }else if( url != ''){
                var urls = window.location.origin +'/'+url;
                window.open(urls, "_blank");
            }else{
                return false
            }
        },
        //开始滚动
        autoPlay() {
            this.animation = setInterval(() => {
                if( this.activeIndex < this.consultList.length) {
                    this.activeIndex += 1;
                } else {
                    this.activeIndex = 0;
                }
            }, this.timeStep)
        },
        //停止滚动
        closeAnimation() {
            clearInterval(this.animation)
        },
        //获取咨询列表
        getConsultList(){
            let url = 'consultcenter/getConsultList';
            this.$ajax('get', url, res => {
                this.consultList = res.data;
                // this.consultList.push({lawyer_id: "7",lawyer_name: "胡小燕",time: 1592387918,user_name: "用户8090",phone:'18893485880'})
            });
        },
        //跳转咨询
        gotoHonsenChat() {
          if( !this.loginStatus ){
            this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
            setTimeout(() => {
              this.$message.warning( '请先登录后，再次执行操作！' );
            }, 200);
            return;
          }
          if(this.$store.state.mineInfo.is_lawyer){
            // 律师跳转咨询页
            let details = this.$router.resolve({
              name: "lawyerChat",
              query: {
                
              }
            });
            window.open(details.href, "_blank")
          }else if(this.$store.state.mineInfo.isSupportStaff){
            //客服跳转咨询管理页，
            let details = this.$router.resolve({
                name: "consultSession",
                query: {
                  
                }
              });
            window.open(details.href, "_blank")
          }else if(this.honsenOffice){
            //管理员跳转咨询管理页，
            let details = this.$router.resolve({
                name: "customerRecord",
                query: {
                  
                }
              });
            window.open(details.href, "_blank")
          }else{
            //用户跳转咨询页
            let details = this.$router.resolve({
              name: "chats",
              query: {
                visitUrl:window.location.href
              }
            });
            window.open(details.href, "_blank")
          }
        },
        filterName(name,phone){
            if(name.substring(0,2) == '用户'){
                return phone.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2')
            }else{
                if(name.length <= 1){
                    return name.substring(0,1) + '***';
                }else{
                    return name.substring(0,2) + '***';
                }
            };
        },
    },
    watch:{
        activeIndex: {
            deep: true,
            handler(v,ov) {
                if (v == 0) {
                    this.timeStep = 0
                } else {
                    this.timeStep = 2000
                }
            }
        }
    },
    filters: {
        timeconvert(date) {
            if( moment().diff(moment(date * 1000), 'days') <= 30 ){
                return moment(date * 1000).fromNow();
            }else{
                // return moment(date * 1000).format('YYYY/MM/DD');
                return '1 个月前'
            }
        },
        filtername(str){
            if(str.length <= 1){
                return str.substring(0,1) + '***';
            }else{
                return str.substring(0,2) + '***';
            }
        },
    },
}
</script>




// WEBPACK FOOTER //
// src/components/home/home.vue